import { useTranslation } from 'react-i18next';

import { ContentLayout } from '../../layout/ContentLayout';
import PageMetatags from '../../layout/PageMetatags';
import ChainsOverviewCard from './ChainsOverviewCard';

const ChainsOverviewPage = () => {
  const { t } = useTranslation();

  return (
    <ContentLayout>
      <PageMetatags title={t('pages:chains.meta.title')} />
      <ChainsOverviewCard />
    </ContentLayout>
  );
};

export default ChainsOverviewPage;
